import Icon from "@cayuse/shared-react.components.icon";
import React from "react";
import styles from "./styles.css";

const DateComponent = () => {
	return (
		<div className={styles.dateInput}>
			<Icon className={styles.dateIcon} name="calendar-alt" variant="regular" size="bigger" />
		</div>
	);
};

DateComponent.information = {
	type: "date",
	name: "Date"
};

export default DateComponent;
